import React from 'react'
import { Rows } from '@paper-monster/web/src/components/layout'
import { Text } from '@paper-monster/web/src/components/common'
import MailingListOptInForm from '@paper-monster/web/src/components/Pages/EmailPreferences/MailingListOptInForm'
import { useSiteConfig } from '@paper-monster/web/src/components/Providers/SiteConfigProvider'

import styles from './Footer.module.scss'

export default function FooterMailingList() {
  const { sources } = useSiteConfig()

  return (
    <Rows className="dark-background" gap={12}>
      <Text.H4 bold className={styles.listHeader} messageId="footer.mailingList.header" onTint size="small" type="body" />
      <Text.P messageId="footer.mailingList.label" onTint size="xsmall" />
      <MailingListOptInForm emailOnly source={sources.newsletter} />
    </Rows>
  )
}
